export const TableId = {
  BATCH_LIST: 'batch-list',
  USER_LIST: 'user-list',
  PRODUCT_LIST: 'product-list',
  PRODUCTS_TABLE: 'products-table',
  PACKAGE_LIST: 'package-list',
  MASTERSUITE_LIST: 'mastersuite-list',
  OUTPUT_COLLECTIONS_LIST: 'output-collections-list',
  SETTING_LIST: 'setting-list',
} as const;

export type TableIdType = (typeof TableId)[keyof typeof TableId];
